module.exports = __webpack_public_path__ + "assets/urendeclareren4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documentation/images/urendeclareren4.jpg
// module id = 368
// module chunks = 0